import {
  ConstantKeyImg,
  ConstantKeysWidgets,
  Widget,
} from '../../app/projects/PDFBuilder/WidgetsList';
import API from '../../app/services/API';

const api = new API();

type WidgetFormat = {
  key: ConstantKeysWidgets;
  data: { text?: string; img?: ConstantKeyImg };
};

export const getPdf = async (
  currentProjectId: number,
  currentIndicatorId: number = 1,
  widgetsInDropZone: Widget[]
) => {
  const widgetsFormat: WidgetFormat[] = widgetsInDropZone.map((widget) => ({
    key: widget.key,
    data: { text: widget.text, sortedBy: widget.data?.sortedBy },
  }));
  return api
    .getPdf(currentProjectId, currentIndicatorId, widgetsFormat)
    .then((response) => response)
    .catch((error) => error);
};
